import { call, put, takeLatest } from "redux-saga/effects"
import { GET_DATA_ENPS_WATCHER } from "./constants"

import { getDataEnpsSuccess, getDataEnpsFailed } from "./actions"
import { getDataEnpsApi } from "../../../utils/routes/routes-report"

export function* getDataEnpsSaga(action) {
  try {
    const dataStatus = action.payload
    const { data: dataEnps } = yield call(getDataEnpsApi, dataStatus.params)
    yield put(getDataEnpsSuccess(dataEnps))
  } catch (e) {
    yield put(getDataEnpsFailed())
  }
}

export default function* widgetChartEnpsSaga() {
  yield takeLatest(GET_DATA_ENPS_WATCHER, getDataEnpsSaga)
}
